import { CModalBody } from "@coreui/react"

import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
} from "@mui/material"

import { Typography } from "@mui/material"

export const equipment_data = [
	{
		title: "Los Sticks",
		id: "stick", //This field must be the same than the "name" field in "hockey_equipment.json" (that contains the area description)
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					Los sticks son la única parte del equipo que puede tocar el disco, por
					lo tanto, son tan importantes como las aletas, las gafas o el guante.
					Vamos a analizar con detalle cada aspecto de esta pieza.
				</Typography>
				<Typography>
					El stick es uno de los elementos más importantes de un jugador, suelen
					medir entre 20 y 25 cm de largo, y los jugadores los usan siempre a
					pares, uno negro y uno blanco.{" "}
				</Typography>
				<Typography>
					Los hay más grandes, más pequeños, más ágiles, prácticamente hay un
					stick para cada estilo de juego y en los clubs cada jugador suele
					tener sus preferidos. Ah y existen sticks de diestros y sticks de
					zurdos.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">La forma y el color</Typography>
				<br></br>
				<Typography>
					La forma de los sticks está regulada por la CMAS de una forma muy
					específica, aunque permite cierto margen para que surjan muchas
					variedades que analizaremos más adelante.
				</Typography>
				<Typography>
					Los sticks pueden ser para diestros o para zurdos, e incluso existen
					un par de modelos para ambidiestros, solo hay que tener en cuenta
					estas reglas:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El stick puede sostenerse tanto con la mano derecha como con la
							izquierda; se permite cambiar de mano de juego tantas veces como
							se quiera durante un partido.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Un jugador podrá tener las dos manos en el stick cuando no esté en
							posesión del disco (por ejemplo, al tratar de lograr una posición
							aerodinámica cuando corre hacia un disco o al tratar de recuperar
							un stick caído), pero la mano libre no podrá utilizarse para
							apoyar el stick, la mano del stick o el brazo mientras se esté en
							posesión del disco. (esto nos diferencia del hockey hierba o del
							hockey hielo)
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Dimensiones:</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Debe caber en una caja de 100mm x 350mm x 50mm.
						</ListItemText>
					</ListItem>

					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El radio mínimo de las esquinas alrededor del borde perimetral de
							todo el stick es de 10mm
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>

						<ListItemText>
							Los bordes donde se cruzan las superficies deben ser redondeados.
						</ListItemText>
					</ListItem>

					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Puede tener cualquier forma o diseño dentro de las dimensiones
							mínimas y máximas indicadas.
						</ListItemText>
					</ListItem>

					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Se permite el uso de pomos en el stick (lo que sea que signifique
							eso).
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Limitaciones:</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El stick no debe ser capaz de rodear el disco o cualquier parte de
							la mano, ni encapsular el disco en más de un 50%, ni fijar o unir
							el disco al stick.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El stick no puede sobresalir del talón (la parte inferior) de la
							mano más de 25mm, por la parte del pulgar, puede sobresalir lo que
							sea dentro de las dimensiones.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>Debe ser estructuralmente sólido</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Si el Árbitro Principal o el Árbitro de Agua determinan que el
							stick puede causar daño, el stick puede ser retirado del juego
							para ese partido.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El stick debe ser uniformemente negro o blanco. Sin embargo, puede
							tener marcas discretas en un color que contraste para su
							identificación.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Si el Árbitro Principal o el Árbitro de Agua determinan que las
							marcas pueden crear confusión en cuanto al color del stick, puede
							ser retirado del juego para ese partido.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El stick puede ser fijado a la mano de juego de forma que no pueda
							causar daño o interferir con el disco.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							La "zona de juego" del stick es la zona que no está cubierta por
							la mano protegida y por delante del pulgar y el índice donde se
							apoyan en el stick. El disco no puede ser jugado con la parte del
							stick que puede sobresalir del talón (la parte inferior) de la
							mano protegida
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Material:</Typography>
				<br></br>
				<Typography>
					Hace muchos años los sticks se hacían de madera, pero ahora están
					hechos de plástico y fibras o resinas muy sofisticados y se pueden
					encontrar muchas variedades distintas
				</Typography>
				<List>
					<ListSubheader>Madera</ListSubheader>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Los primeros sticks se hacían de madera, y permitían que cada
							jugador se hiciera el suyo a su gusto, tallándolo y ajustándolo a
							sus necesidades, pero esto no permitía a los jugadores hacer dos
							sticks iguales, y además la madera podía llegar a absorber humedad
							con el tiempo, a decolorarse, y a perder volumen por la parte que
							estuviera más en contacto con la superficie de la piscina. A día
							de hoy, la mayoría de jugadores utiliza sticks de otros
							materiales.
						</ListItemText>
					</ListItem>
					<ListSubheader>Plástico resina y goma</ListSubheader>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Los sticks de plástico se fabrican a partir de moldes
							tradicionales o impresos en 3D, y permiten reproducir el mismo
							modelo tantas veces como quiera el fabricante (porque suelen ser
							fabricados por empresas, y no por los jugadores). Las propiedades
							del material con el que estén fabricados hacen que el stick pueda
							ser más ligero que el de madera, impermeable, sólido y que no
							requiera pintura. Incluso hay sticks que añaden al plástico una
							capa de goma que permite que el disco se pegue mejor a la
							superficie.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Movimientos con el stick</Typography>
				<br></br>
				<Typography>
					Con el stick no solo se puede empujar el disco hacia delante o en
					cualquier dirección, para llevarlo a la portería, también se pueden
					hacer unos cuantos gestos y regates bastante utilizados por los
					jugadores para obtener ventaja frente a sus oponentes.
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Tirar:</b> un stick en manos de un buen jugador puede conseguir
							que el disco se levante del suelo y se desplace muy rápido, muy
							alto, y muy lejos, entre 1 y 2 metros aproximadamente. El tiro se
							suele hacer hacia delante, como si un jugador de futbol le pegara
							una patada a un balón, y es fundamental para conectar jugadas
							entre un jugador y otro.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Tirar de gancho:</b> El stick puede utilizarse para pasar el
							disco hacia detrás del jugador, y de nuevo, se pueden conseguir
							tiros muy altos y largos si el jugador es suficientemente
							habilidoso.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Regatear:</b> Con el stick y el disco se pueden hacer muchos
							regates a otros jugadores, para salir de la presión, para
							conseguir espacio para dar luego un pase, el regate es todo un
							arte.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Pisar el disco:</b> En determinadas superficies, y con un stick
							adecuado, se puede pisar el disco para desplazarlo.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Lo que no se puede:</b> El disco no debe levantarse ni llevarse
							en ninguna dirección mientras esté equilibrado o encima del stick;
							y en caso de que el disco se levante accidentalmente en un stick,
							deberá soltarse inmediatamente.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Mantenimiento del stick</Typography>
				<br></br>
				<Typography>
					Los sticks pueden durar muchos años si se cuidan bien, aquí os dejamos
					un par de consejos para mantenerlos durante el mayor tiempo posible
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Decoloración:</b> Especialmente si el stick es de madera, y
							blanco, el color se puede llegar a perder, el stick puede volverse
							amarillo o puede mancharse de otros colores. Lo mejor para
							mantener los sticks con su color original es protegerlos de la luz
							del sol y tratar de no ponerles cintas en el mango. Y si pierden
							el color, siempre se pueden llegar a pintar de nuevo.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Rotura:</b> Si un stick se rompe por un golpe, no habrá mucho
							que hacer salvo cambiarlo. No está permitido volver a unirlo con
							tornillos o burletes. Para evitar roturas no hay muchos secretos,
							simplemente al guardarlos procura que no se queden en una posición
							donde algo de peso pueda estar empujando contra su superficie, si
							el stick no reposa sobre plano.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Fabricantes de sticks</Typography>
				<br></br>
				<Typography>
					Los mejores sticks proceden de dos tiendas fundadas por jugadores
					legendarios de este deporte. Sin duda, os recomendamos echar un
					vistazo a sus páginas web y a sus perfiles en RRSS
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Bentfish:</b>{" "}
							<a href="https://bentfishdesign.com">
								https://bentfishdesign.com
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Hydrouwh:</b>{" "}
							<a href="https://hydrouwh.com">https://hydrouwh.com</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Tipos de sticks</Typography>
				<br></br>
				<Typography>
					No tenemos espacio para hablar de todos ellos (aún), pero sí podemos
					hacer una pequeña mención a los más populares entre los jugadores del
					club
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Carve:</b> Fabricado por Bentfish:{" "}
							<a
								href="https://bentfishdesign.com/product/carve-279-2011"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/carve-279-2011
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Hydra:</b> Fabricado por Bentfish:{" "}
							<a
								href="https://bentfishdesign.com/product/hydra-2"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/hydra-2
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Scalpel:</b> Fabricado por Bentfish:{" "}
							<a
								href="https://bentfishdesign.com/product/scalpel-2012"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/scalpel-2012
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Tapper:</b> Fabricado por Bentfish:{" "}
							<a
								href="https://bentfishdesign.com/product/tapper-2011"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/tapper-2011
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Stingray:</b> Fabricado por HydroUwh:{" "}
							<a
								href="https://hydrouwh.com/collections/sticks/products/stingray-sticks"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/sticks/products/stingray-sticks
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Rocket:</b> Fabricado por HydroUwh:{" "}
							<a
								href="https://hydrouwh.com/collections/sticks/products/rocket-260-sticks"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/sticks/products/rocket-260-sticks
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Katana:</b> Fabricado por HydroUwh:{" "}
							<a
								href="https://hydrouwh.com/collections/sticks/products/katana-sticks"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/sticks/products/katana-sticks
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Dorsal:</b> Fabricado por HydroUwh:{" "}
							<a
								href="https://hydrouwh.com/collections/sticks/products/dorsal-elite-sticks"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/sticks/products/dorsal-elite-sticks
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
		],
	},
	{
		title: "Los Guantes",
		id: "glove",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					El guante protege la mano de dos enemigos muy importantes: el suelo de
					la piscina, y otros sticks. Al hockey no se puede jugar sin él, y por
					eso, como el stick y las aletas, es un elemento muy importante.
				</Typography>
				<Typography>
					Hablaremos de “el guante” porque normalmente solo se juega con una
					mano, pero realmente se podrían llegar a llevar dos, aunque esto sería
					poco práctico.
				</Typography>
				<Typography>
					El guante típico de hockey cubre la mano entera, desde la muñeca, y
					todos los dedos de una mano.
				</Typography>
				<Typography>
					Suele tener la forma de un puño, ya que así se facilitará el agarre
					del stick con la mano que lo lleva.
				</Typography>
				<Typography>
					Depende del modelo, la parte de la palma de la mano puede ir abierta o
					puede tener una capa fina de tela. La idea, es que la parte superior
					de la mano, que está expuesta a otros sticks, quede protegida, y la
					parte de los dedos que puede tocar con el suelo, también.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Materiales</Typography>
				<br></br>
				<Typography>
					Los más veteranos del club seguramente recordarán tiempos más oscuros
					donde los guantes eran de fregar (!!) o de algún tipo de resina muy
					pegajosa que se quedaba pegada a todo lo que tocaba. Pero hoy en día
					el guante está hecho de diferentes materiales muy resistentes y
					protegen a los jugadores de golpes y cortes.
				</Typography>
				<Typography>
					El material más habitual que se utiliza para hacer un guante es la
					silicona, que permite que cada guante sea resistente a los golpes,
					flexible, y razonablemente poco pesado. Aunque ahora también se pueden
					conseguir de goma, que tiene algo más de resistencia que la silicona,
					aunque es más difícil de manipular.
				</Typography>
				<Typography>
					La silicona se suele echar encima de un guante de tela, aquí
					encontramos muchos tipos de tejidos que se utilizan, desde algodón,
					hasta guantes un poco más sofisticados de trabajo, donde la tela que
					se utiliza es resistente incluso a los cortes.
				</Typography>
				<Typography>
					Lo que sí parece que está extendido es no utilizar guantes con
					materiales a donde la silicona no se pueda adherir, ya que reduciría
					mucho la duración del guante, y por lo tanto la protección de la mano
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Forma</Typography>
				<br></br>
				<Typography>
					En realidad, la CMAS dice que las manos pueden ir protegidas por algo
					que no sea un guante, literalmente las reglas dicen que “La protección
					de las manos (por ejemplo, los guantes)” no debe contener material de
					refuerzo rígido o afilado.” Pero hasta ahora no conocemos a nadie que
					lo que lleve para protegerse no sea eso, un guante.
				</Typography>
				<Typography>
					Los guantes utilizados para la protección de las manos no podrán tener
					bandas entre los dedos ni tener un diseño que ayude a nadar. No se
					pueden utilizar guantes de natación con membranas, aunque si se lleva
					el stick en esa mano, se utilizarían poco.
				</Typography>
				<Typography>
					La forma de protección de los dedos se ha ido sofisticando con el paso
					de los años, antes, o ahora cuando un jugador se quiere hacer un
					guante a medida, la silicona se puede ir moldeando con la otra mano,
					con un palo de madera, o incluso con algún tipo de espátula, pero los
					guantes que se fabrican en serie se fabrican a partir de moldes
					impresos en 3D que consiguen un diseño espectacular.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Colores</Typography>
				<br></br>
				<Typography>
					Un guante puede ser de cualquier color, pero deberá ser de un color
					que contraste fuertemente con el color del stick del jugador y con el
					color de la camiseta (si es que lleva) del jugador y del color del
					disco utilizado en el partido.{" "}
				</Typography>
				<Typography>
					Esto se recoge así para evitar la confusión si el disco está siendo
					controlado por un jugador, ya que está prohibido tocar el disco con
					algo que no sea el stick.
				</Typography>
				<Typography>
					Los jugadores tampoco podrán llevar un guante de un color que pueda
					confundirse con los guantes de los árbitros de agua, que suelen ser
					rojos o naranjas
				</Typography>
				<Typography>
					La mayoría de los guantes suelen ser azules o verdes, pero para los
					entrenamientos o para torneos locales se han llegado a ver guantes
					rojos, rosas, amarillos…
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Cuidado y mantenimiento</Typography>
				<br></br>
				<Typography>
					Un guante se va a desgastar con el uso, y se va a ir debilitando con
					el paso del tiempo, tanto por posibles golpes, como por el ciclo de
					humedad-secado que se va a producir cada vez que se utilice.
				</Typography>
				<Typography>
					Muchas veces es posible alargar la vida útil reparando con silicona
					nueva aquellas zonas que se han podido quedar más desgastadas, como el
					dedo pulgar o el dedo índice, pero llega un momento que el guante es
					mejor que quede para una vitrina que para jugar un buen partido.
				</Typography>
				<Typography>
					También se pueden llegar a coser algunos trozos si la tela se va
					rompiendo por alguna parte, pero tampoco va a alargar la vida del
					guante demasiado.
				</Typography>
				<Typography>
					No sabemos de estudios científicos que lo avalen, pero suponemos que
					el cloro tampoco ayudará a que el guante se conserve muy bien.
					Recomendamos si es posible echarle agua del grifo de vez en cuando,
					idealmente si es después de entrenar, e intentar dejarlo al aire para
					que se seque cuanto antes y evitar la aparición de moho, porque tal y
					como suelen estar hechos, con la silicona cubriendo todos los dedos,
					el dorso de la mano y parte de la palma, será muy fácil que se acumule
					la humedad si no tenemos cuidado (Aunque hay jugadores que son
					expertos en mantener un guante húmedo durante semanas e incluso meses){" "}
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Personalización</Typography>
				<br></br>
				<Typography>
					No hay límites en las reglas de la CMAS a lo que pueda llevar el
					guante escrito o en su superficie, en cuanto a mensajes, nombres o
					escudos, aunque en los torneos importantes, el director del torneo
					puede decidir que un guante no es apto para competir
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Fabricantes</Typography>
				<br></br>
				<Typography>
					Los mejores guantes proceden, como los sticks, de varias tiendas
					fundadas por jugadores legendarios de este deporte. Sin duda, os
					recomendamos echar un vistazo a sus páginas web y a sus perfiles en
					RRSS
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Bentfish:<br></br>
							<a
								href="https://bentfishdesign.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Hydrouwh:<br></br>
							<a
								href="https://hydrouwh.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Moresport:<br></br>
							<a
								href="https://uwhstore.more-sport.com/en/articles/11-glove-for-underwater-hockey.html "
								target="_blank"
								rel="noopener noreferrer"
							>
								https://uwhstore.more-sport.com/en/articles/11-glove-for-underwater-hockey.html
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							CoreUWHGear:<br></br>
							<a
								href="https://coreuwhgear.com/product/uwh-euro-glove/"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://coreuwhgear.com/product/uwh-euro-glove/
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							UWHShop:<br></br>
							<a
								href="http://www.uwhshop.com/product-category/uwh-equipment/uwh-gloves-and-sticks/"
								target="_blank"
								rel="noopener noreferrer"
							>
								http://www.uwhshop.com/product-category/uwh-equipment/uwh-gloves-and-sticks/
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
		],
	},
	{
		title: "Los Gorros",
		id: "cap",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography></Typography>
				<Typography></Typography>
				<Typography></Typography>
			</CModalBody>,
		],
	},
	{
		title: "Las Aletas",
		id: "fins",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					Las aletas permiten a los jugadores moverse por el agua y sobre todo
					bajar hasta el fondo de la piscina sin tener que usar sus brazos.
				</Typography>
				<Typography>
					Las aletas, junto con las gafas, son uno de los materiales que más
					variedad de modelos y tipos pueden tener, porque se utilizan fuera del
					hockey, en otros deportes como la apnea, el buceo o la natación,
					aunque a día de hoy existen aletas específicas de hockey también.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">La forma y ¿el color?</Typography>
				<br></br>
				<Typography>
					Con las aletas ocurre que no están reguladas especialmente en el
					reglamento oficial de la CMAS, como sí ocurre con otros materiales,
					por lo tanto, se pueden encontrar en los campeonatos oficiales muchos
					tipos de aletas, en función de lo que quiera cada jugador.
				</Typography>
				<Typography>
					No suelen ser muy largas, como las de apnea o buceo, porque no
					permitirían a un jugador mover las piernas muy rápido, pero tampoco
					suelen ser muy cortas, como las de natación o bodyboard, porque no
					generarían suficiente desplazamiento de agua como para poder moverse
					por el fondo de la piscina con suficiente rapidez sin cansarse. El
					punto intermedio es el más adecuado y cada jugador debe encontrar el
					suyo.
				</Typography>
				<Typography>
					El reglamento no especifica nada de las monoaletas, pero no conocemos
					a nadie que se haya atrevido a jugar con ellas (si es que en un torneo
					lo llegasen a permitir), por el tipo de juego que se desarrolla en el
					fondo de la piscina, en hockey es más interesante tener las dos
					piernas sueltas que unidas en una sola aleta.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Tipos de aletas</Typography>
				<br></br>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Pie abierto / Pie cerrado:</b> Decidirse a utilizar aletas de
							pie abierto o de pie cerrado es como elegir entre coca-cola y
							pepsi, o entre Marvel y DC, cada bando defenderá sus ventajas
							hasta la muerte y en muchas ocasiones negará los beneficios que
							tiene usar las aletas del bando contrario. Los modelos de aletas
							que tienen el pie abierto, suelen tener la ventaja de ser más
							ligeros y por lo tanto en teoría algo más rápidos y ágiles que los
							modelos de pie cerrado, que por el contrario, son más cómodos y
							holgados, permitiendo mayor circulación y comodidad durante un
							torneo entero.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Con o sin escarpines:</b>A veces, si la aleta se ha dado de sí,
							o simplemente por comodidad y para evitar rozaduras, hay jugadores
							que se calzan unos escarpines de los de buceo (es decir, sin suela
							rígida) para llevar por dentro de la aleta.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Con o sin sujetaletas:</b> El sujetaletas es un complemento
							bastante interesante sobre todo para torneos o competiciones donde
							cualquier detalle cuenta. Suele tratarse de una pieza de goma muy
							sencilla, que añade un nivel extra de sujección de la aleta a la
							pierna, y evita que se escape en una salida hacia el disco desde
							la pared, o por algún enganche con otro jugador sin querer
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Sin accesorios:</b> Algunos modelos de aletas, especialmente
							los de buceo, llevan hebillas de metal o de plástico para
							ajustarlas mejor en la parte del pie. Estos modelos no están
							permitidos, al poder golpear a alguien de una patada o engancharse
							a cualquier parte del cuerpo y hacer bastante daño. Quizás es la
							única limitación que exista con las aletas.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Lo del color o los dibujos:</b> El color puede ser el que cada
							jugador quiera, por lo que encontramos bastante variedad en los
							torneos, y a veces es posible no ver las mismas aletas en todos
							los miembros de un equipo. Mirad en la web de MoreSport los
							diseños que venden para pegar en las de fibra:
							<br></br>
							<a href="https://uwhstore.more-sport.com/en/3-fins-sticker">
								https://uwhstore.more-sport.com/en/3-fins-sticker
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Materiales</Typography>
				<br></br>
				<Typography>
					De goma, de fibra de vidrio, de fibra de carbono, de plástico,
					cualquier material está permitido siempre que forme parte de la aleta
					y no corte a los demás jugadores. Como en cualquier tienda de deporte
					encontramos aletas de todos los tipos, el material que se elija
					dependerá del presupuesto y los gustos de cada jugador.
				</Typography>
				<Typography>
					Las aletas de plástico y goma suelen ser las más económicas, y las de
					fibra de vidrio y carbono, las más caras.
				</Typography>
				<Typography>
					A día de hoy, salvo algún modelo muy concreto, las aletas de fibra
					suelen ser las más populares entre la mayoría de jugadores para
					competir, por su reactividad y dureza, ya que permiten ejercer mayor
					fuerza con menor esfuerzo. A lo mejor con palabras es difícil de
					explicar, os animamos a que probéis dos modelos, y veréis la
					diferencia.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Cuidado y mantenimiento</Typography>
				<br></br>
				<Typography>
					Las aletas están sometidas a bastante caña, sobre todo las de
					competición, así que todo el cuidado que reciban estará bien dado. Si
					las aletas son de goma, pueden ser un poco más resistentes fuera del
					agua, pero lo mejor es tratar a todos los modelos con el máximo
					cuidado.
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							No hay que dejarlas al sol, o en un coche en verano cuando haga
							calor. Suelen reblandecerse y perder propiedades
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							No hay que apoyar mucho peso encima, especialmente si están sobre
							un canto o un bordillo
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Si es posible, hay que evitar que estén en contacto con líquidos
							muy agresivos, por si las partes de goma se dañan. Lo del cloro
							después de la piscina no sabemos deciros si es super dañino, de
							primeras no lo es, pero seguro que un bañito de agua nada más
							salir no les hará ningún daño
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							A veces, se pueden reparar con cinta americana, o incluso con algo
							de silicona, no quedará bonito ni elegante, pero sí efectivo,
							sobre todo para los cantos, que por el uso pueden perder los
							trozos de goma que los protegen.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Los modelos más populares</Typography>
				<br></br>
				<List>
					<ListSubheader>Goma</ListSubheader>

					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Najade:</b> Unas aletas de pie abierto muy cortas y rígidas,
							pero con una capacidad de patada bastante similar a las de fibra.
							Dice la leyenda que si te las pones del pie contrario y al revés
							consigues mejores resultados.
							<br></br>
							<a
								href="https://bentfishdesign.com/product/najade-uw-fins"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/najade-uw-fins
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Avanti Quattro:</b> Un clásico, aletas indestruibles, que
							aguantarían el paso de un camión sin despeinarse, a cambio, algo
							pesadas salvo que seas un jugador muy grande.
							<br></br>
							<a
								href="http://www.canamuwhgear.com/Mares-Quattro-Fins-p/fin-maresqtro.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								http://www.canamuwhgear.com/Mares-Quattro-Fins-p/fin-maresqtro.html
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Avanti Tre o superchannel:</b> La versión ligera de las Avanti
							Quattro, suelen llevarlas los jugadores más jóvenes, y son un
							modelo estupendo para poder iniciarse en el hockey sin invertir
							demasiado dinero.
							<br></br>
							<a
								href="http://www.canamuwhgear.com/Mares-Tre-Fins-p/fin-tre.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								http://www.canamuwhgear.com/Mares-Tre-Fins-p/fin-tre.html
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Technisub Stratos:</b> Un modelo mucho más ligero que las
							Avanti, y algo más económico, también para principantes o para
							entrenamientos.
							<br></br>
							<a
								href="https://hydrouwh.com/collections/fins/products/technisub-stratos-fp-aqualung"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/fins/products/technisub-stratos-fp-aqualung
							</a>
						</ListItemText>
					</ListItem>

					<ListSubheader>Fibra</ListSubheader>

					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Breier:</b> Seguramente las aletas más populares de hockey
							junto con las Najade y las Avanti. De muchos modelos y durezas
							diferentes, son seguramente de los modelos más caros, pero las
							preferidas por la mayoría de jugadores.
							<br></br>
							<a
								href="http://www.uwhshop.com/product/underwater-hockey-fins-breier/"
								target="_blank"
								rel="noopener noreferrer"
							>
								http://www.uwhshop.com/product/underwater-hockey-fins-breier/
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Fabricantes</Typography>
				<br></br>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Mares:</b>{" "}
							<a
								href="https://www.mares.com/es_ES/home"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.mares.com/es_ES/home
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Decathlón:</b>{" "}
							<a
								href="https://www.decathlon.es/es/search?Ntt=aletas"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.decathlon.es/es/search?Ntt=aletas
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Beuchat (Breier):</b>{" "}
							<a
								href="https://www.beuchat-diving.com/gb/blog/choosing-diving-fins--n109"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.beuchat-diving.com/gb/blog/choosing-diving-fins--n109
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>Najade:</b>{" "}
							<a
								href="https://www.najadefins.org"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://www.najadefins.org
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
		],
	},
	{
		title: "La máscara y el tubo",
		id: "mask",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					Las gafas permiten que cada jugador vea debajo del agua, es su única
					función, y por suerte para el mundo del hockey, no es necesario
					utilizar unas gafas específicas, por lo que nos beneficiamos de que
					existan miles de modelos para snorkel y buceo que pueden servir
					también para nuestro deporte.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Componentes</Typography>
				<br></br>
				<Typography>
					Unas gafas o “máscara” de hockey están formadas por:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Las lentes, o cristales, que suelen ser transparentes, aunque
							también existen tintados.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Una montura donde se encajan las lentes, de plástico o algún
							material rígido similar.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Una cubierta de silicona, que rodea parte de la cara, y que es lo
							que hace que técnicamente las gafas no sean gafas, sino máscara.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Unas tiras o cintas, de silicona o plástico, que permiten sujetar
							todas las piezas a la cabeza del jugador. Existen más sencillas, o
							incluso venden accesorios para conseguir que se ajusten por toda
							la cabeza y que realmente sea imposible que se puedan mover.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Forma y materiales</Typography>
				<br></br>
				<Typography>
					La CMAS restringe un poco el tipo de gafas o “máscara” que se puede
					utilizar. El Reglamento establece que se debe utilizar una máscara con
					diseño de doble lente, o en su caso, una máscara con diseño de lente
					única que incorpore un divisor/soporte central en la montura de la
					máscara. Esto se hace para evitar que si se golpea la gafa, se puedan
					ver afectados los dos ojos.
				</Typography>
				<Typography>
					En cuanto a la montura, se permite llevar una “montura monolítica de
					plástico” que básicamente es lo que incorporan todas las gafas de este
					estilo, no conocemos monturas que no formen una única pieza, al
					contrario que las gafas de natación, que están unidas por un simple
					puente de plástico.
				</Typography>
				<Typography>
					Lo que sí se exige es que todas las lentes deben ser de un material
					resistente a la rotura, lo que hace que muchos de los modelos más
					populares de gafas para hockey estén fabricados con lentes de
					plástico.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Hablemos de escupir</Typography>
				<br></br>
				<Typography>
					Para alguien que está iniciándose en este deporte, puede resultar muy
					llamativo (y asqueroso) que los jugadores, antes de meterse al agua,
					escupan sobre sus gafas y extiendan con el dedo la saliva.{" "}
				</Typography>
				<Typography>
					Esto se hace para evitar que las gafas se empañen al cabo de unos
					pocos minutos, por la condensación. Esto se hace también cuando se
					practica buceo o snorkel en el mar, no es algo exclusivo del hockey.
				</Typography>
				<Typography>
					Existen productos para evitar el empañamiento de las gafas, pero por
					la experiencia de la mayoría de los jugadores, no hay nada mejor que
					la saliva para conseguir una lente limpia hasta el final de un
					partido.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Cuidado y mantenimiento</Typography>
				<br></br>
				<Typography>
					Si las gafas tienen una lente de plástico, lo mejor es evitar que la
					lente pueda rozar con cualquier otra superficie, porque acabarán
					rallándose mucho más fácilmente que si la lente es de cristal
					templado. Lo más habitual, es guardarlas siempre en la caja en la que
					vienen al comprarlas.
				</Typography>
				<Typography>
					En cuanto a otro tipo de cuidados, basta con aclararlas con agua del
					grifo después de cada entrenamiento, para evitar que el cloro pueda
					dañar los materiales, y si es posible, evitar guardarlas con humedad
					para evitar la aparición de hongos.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Fabricantes y modelos populares</Typography>
				<br></br>
				<Typography>
					Hay un tipo concreto de gafa, de cristal curvado, que es uno de los
					más populares entre los jugadores, porque permite tener un campo de
					visión mucho más amplio hacia los laterales. Os dejamos un par de
					enlaces interesantes para que descubráis cómo son:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<a
								href="https://hydrouwh.com/collections/headgear/products/curve-mask"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/headgear/products/curve-mask
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<a
								href="https://es.aqualung.com/es/aqualung-master-catalog/sphera-x-MS4700975LMB.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://es.aqualung.com/es/aqualung-master-catalog/sphera-x-MS4700975LMB.html
							</a>
						</ListItemText>
					</ListItem>
				</List>
				<Typography>
					En cuanto a otros modelos, encontramos muchísima variedad (por ejemplo
					en Europa, es bastante común encontrar gafas en Decathlon), cualquier
					máscara que os guste, os resulte cómoda y esté permitida por la CMAS,
					será suficiente para que podáis jugar con ella.
				</Typography>
				<Typography>Sujeciones de gafas interesantes:</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<a
								href="https://bentfishdesign.com/product/secure-webbing-mask-strap"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/secure-webbing-mask-strap
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<a
								href="https://bentfishdesign.com/product/beaver-strap"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com/product/beaver-strap
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<a
								href="https://uwhstore.more-sport.com/en/articles/12-strap-for-mask.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://uwhstore.more-sport.com/en/articles/12-strap-for-mask.html
							</a>
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
		],
	},
	{
		title: "Disco",
		id: "puck",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					El disco es el “balón” o la “pelota” con el que se juega al hockey. Es
					lo que los jugadores se disputan, y por lo tanto, uno de los elementos
					sin los cuales no se puede jugar, claro… Está pensado para deslizarse
					por el fondo de la piscina, no flota, y como en algunas otras
					secciones, encontramos discos de todo tipo.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Tamaño y forma</Typography>
				<br></br>
				<Typography>
					El disco se parece a un disco de hockey hielo, aunque con algunas
					particularidades. El núcleo es de plomo pero está recubierto por una
					cubierta de plástico
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El disco debe tener un diámetro de 80mm (se permite ±4mm de
							diferencia), y un espesor de 30mm, (se permite +4mm o -2mm de
							diferencia). Estas dimensiones son exteriores, es decir, incluyen
							el disco y la cubierta protectora.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							El radio del borde del disco, cubierto o no, deberá ser de 3mm a
							10mm de radio.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Debe pesar 1,3 kg (se permite ±0,2Kg de diferencia)
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							En cuanto al color, debe ser de un color brillante y distintivo.
							Se prefiere el rosa o el naranja.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Cuidado y mantenimiento</Typography>
				<br></br>
				<Typography>
					Realmente tiene poco, no suele pasarle nada si no se seca, solo está
					formado por dos piezas, pero en realidad no se suele desmontar así que
					a efectos prácticos es solo una pieza, y quizás el cuidado debe estar
					con la piscina y sus baldosines, más que con el propio disco en sí
					mismo.
				</Typography>
				<Typography>
					Hay ciertos modelos de discos en los que la cubierta de plástico está
					fijada al núcleo de plomo con 4 tornillos. En este caso, el cuidado
					deberá centrarse en que los tornillos se mantengan en su sitio y que
					la tapa no se vaya rompiendo con el uso.
				</Typography>
				<Typography></Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Fabricantes</Typography>
				<br></br>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Bentfish:<br></br>
							<a
								href="https://bentfishdesign.com"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://bentfishdesign.com
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Hydrouwh:<br></br>
							<a
								href="https://hydrouwh.com/collections/pucks"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://hydrouwh.com/collections/pucks
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Moresport:<br></br>
							<a
								href="https://uwhstore.more-sport.com/en/clubs/160-puck-for-underwater-hockey.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								https://uwhstore.more-sport.com/en/clubs/160-puck-for-underwater-hockey.html
							</a>
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							CanAm Uwh Gear:<br></br>
							<a
								href="http://www.canamuwhgear.com/Pucks-s/1817.html"
								target="_blank"
								rel="noopener noreferrer"
							>
								http://www.canamuwhgear.com/Pucks-s/1817.html
							</a>
						</ListItemText>
					</ListItem>
				</List>
				<Typography></Typography>
				<Typography></Typography>
				<Typography></Typography>
			</CModalBody>,
		],
	},
	{
		title: "El tubo/tuba/Snorkel y el cubrebocas",
		id: "tube",
		pages: [
			<CModalBody>
				<Typography variant="h5">Intro</Typography>
				<br></br>
				<Typography>
					Con este accesorio no nos vamos a poner ninguno de acuerdo con el
					nombre, ni con su género, hay quien lo llama tubo, hay quien lo llama
					tuba, y hay quien lo llama snorkel directamente, como se llama en
					inglés. Pero todos entendemos a qué nos referimos. El tubo permite al
					jugador respirar cuando sube a la superficie.{" "}
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">La necesidad del tubo</Typography>
				<br></br>
				<Typography>
					Lo de la botella, o bombona, y lo de si llevamos patines como el
					hockey hierba, es la pregunta más habitual que nos suelen hacer. El
					juego se desarrolla por el fondo de la piscina, y en el tubo no se
					guarda aire ni nada, cuando bajas al fondo, tienes que guardar el aire
					en tus pulmones y aguantar, pero al subir, como el juego es muy
					rápido, el tubo te permite seguir mirando el campo mientras respiras y
					te recolocas.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Materiales, y la forma</Typography>
				<br></br>
				<Typography>
					La CMAS permite utilizar un tuboflexible que no sea de metal. Suelen
					ser de plástico o silicona, incluso algún jugador muy bestia ha
					llegado a utilizar trozos de manguera de jardín cortados y a los que
					le ha pegado una boquilla (no estamos bromeando)
				</Typography>
				<Typography>
					Y lo que sí se exige es que los jugadores utilicen un
					dispositivo/protector que los proteja adecuadamente contra lesiones en
					sus dientes y encías. Algo parecido a lo que pueden llevar los
					boxeadores en la boca, pero adaptado a que en hockey tenemos también
					que llevar un tubo en la boca, por lo que se han creado varios
					protectores bastante cómodos para llevar al mismo tiempo.
				</Typography>
				<Typography>
					En cuanto al color, no está restringido. Muchos jugadores en los
					europeos y mundiales cubren sus tubos con cintas adhesivas con el
					color de la bandera de su país, y quedan genial.
				</Typography>
				<Typography></Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">
					Tamaño, díametro y expulsador de agua
				</Typography>
				<Typography>
					Como el tubo solo se utiliza al salir a respirar, y el jugador debe
					moverse lo más rápido posible, los tubos suelen ser cortos, y no
					superan la cabeza del jugador cuando la saca del agua, al contrario
					que algunos tubos de snorkel, que sí están diseñados para utilizar en
					el mar, con algo de olas, y suelen ser bastante más largos y
					sobresalir por encima de la cabeza de la persona que los lleva.
				</Typography>
				<Typography>
					Muchos tubos de snorkel llevan en la punta un accesorio para evitar
					que el agua entre, de nuevo, por alguna ola, pero en el caso del
					hockey, cuanto más sencillo y ligero, mejor, además de que ese
					accesorio puede evitar que se expulse el aire y el agua más rápido, e
					incluso puede cortar a algún otro jugador. En los torneos oficiales no
					se suele permitir.
				</Typography>
				<Typography>
					Y en cuanto a la boquilla, muchos tubos de snorkel llevan también un
					mecanismo para expulsar agua directamente desde la zona de la boca, en
					vez de tener que desplazar el agua por todo el tubo hasta la
					superficie. Esto se hace así para evitar que los buceadores o bañistas
					tengan que hacer un esfuerzo extra por echar el agua cuando están
					tranquílamente disfrutando de un baño en el mar, pero en hockey, es
					del todo innecesario. Cuando se juega rápido y con cierto ritmo, un
					jugador no va a tener problemas en expulsar el agua sin necesidad de
					utilizar estos accesorios, que pueden dificultar el uso de un
					protector de boca o incluso pueden ser prohibidos en los torneos
					oficiales, por el mismo motivo que el accesorio de la punta, pueden
					cortar o dañar a otros jugadores si los tocamos o golpeamos sin
					querer.
				</Typography>
			</CModalBody>,
			<CModalBody>
				<Typography variant="h5">Cuidado y mantenimiento.</Typography>
				<Typography>
					El tubo es uno de los materiales que menos hay que cuidar, porque no
					se puede hacer mucho con él. Suele ser resistente y no estar sometido
					a muchas tensiones, salvo por dos puntos:
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							Hay jugadores que muerden la boquilla, y al cabo del tiempo tienen
							que cambiarlo
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							A veces, si el tubo tiene mucho tiempo y no se ha secado
							correctamente con frecuencia, puede salir moho por dentro, y se
							tiene que cambiar.
						</ListItemText>
					</ListItem>
				</List>
			</CModalBody>,
		],
	},
]
